import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {CHANNEL_SERVICE, ChannelService} from '../LearningChannelService';
import {Observable} from 'rxjs';
import {environment} from '../../../../../micromate-learn-web/src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ChannelHttpInterceptor implements HttpInterceptor {

    constructor(@Inject(CHANNEL_SERVICE) private channelService: ChannelService) {
    }

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.isBackendRequest(request.url)) {
            const activeChannel = this.channelService.getChannel();
            if (activeChannel !== undefined) {
                request = request.clone({setHeaders: {'Micromate-Channel': activeChannel}});
            }

            return next.handle(request);
        }
        return next.handle(request);
    }

    private isBackendRequest(url: string): boolean {
        const serverUrl = environment.serverUrl;
        return url.startsWith(serverUrl);
    }

}
